const shippingCosts = {
    title: 'Shipping Costs',
    subtitle: 'Discover our shipping options and delivery times for your location',
    selectCountry: 'Select your country',
    availableOptions: 'Available shipping options',
    options: 'options',
    noOptions: 'No shipping options available for this country',
    contactUs: 'Contact us for shipping options',
    default: 'Default',
    free: 'Free',
    minOrderAmount: 'Minimum order amount',
    aboveMinAmount: 'Above minimum amount',
    importantInfo: 'Important Information',
    info1: 'Shipping costs are calculated based on the selected country',
    info2: 'Free shipping is available for orders above the minimum amount',
    info3: 'Delivery times may vary based on your location',
    info4: 'Contact us for special shipping arrangements',
    loading: 'Loading...',
    errorLoading: 'Error loading shipping costs',
    noDescription: 'No description available'
};

export default shippingCosts;
